import { call, put, takeLatest } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import {GET} from "../../api";
import {FETCH_SPACE_LIST, SET_SPACE_LIST} from "../actions";




export function* FetchSpaceListSaga() {


    try {

        const response = yield call(GET, `${ApiRouts.API_SPACE_LIST}` , {});

        if (response) {

            yield put({
                type:SET_SPACE_LIST,
                payload:response.data.data
            });
        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* spaceListSaga() {
    yield takeLatest(FETCH_SPACE_LIST, FetchSpaceListSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default spaceListSaga;
